<template>
  <a-card :bordered='false'>
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="二维码号" name='code_sn'>
        <a-input style="width: 270px" v-model:value="search.code_sn" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item label="二维码类型" name='code_type'>
        <a-select v-model:value="search.code_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">大标</a-select-option>
          <a-select-option :value="2">中标</a-select-option>
          <a-select-option :value="3">小标</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="扫码录入时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <p class="p-t-20">入库商品总数：{{allNum}}</p>
    <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:code_sn="{ record }">
        <a href="javascript:;" v-has:antiAuditQuery='()=>{$router.push("/antiFleeingGoods/marketAudit/tracking?code="+record.code_sn)}'>{{record.code_sn}}{{record.virtual_sn!=0?'(垛标入库)':''}} </a>
      </template>
      <template #title_num>
        入库数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
       <template v-slot:action="{ record }">
          <a-button v-has:antiWarehousingLogDel='()=>del(record)' danger>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>

   

</template>
<script>
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { message, Modal } from "ant-design-vue";
import { iscode } from "@/utils/app";
import {
  getWarehousingMore,
  getWarehousingCode,
  delWarehousingCode,
  getWarehousingCodeNum,
} from "@/api/antiFleeing";
const defSearch = {
  page: 1,
  limit: 10,
  code_type: "",
  code_sn: "",
  warehousing_sn: "",
  start_time: "",
  end_time: "",
};
export default {
  props:{id:String},
  components: { InfoCircleOutlined},
  setup(props) {
    const search = ref({ ...defSearch });
    const state = reactive({
      orderData: {},
      time: [],
      list: [],
      allNum: 0,
      total: 0,
      columns: [
        {
          title: "二维码号",
          dataIndex: "code_sn",
          key: "code_sn",
           slots: { customRender: "code_sn" },
        },
        {
          title: "二维码类型",
          dataIndex: "code_type_text",
          key: "code_type_text",
        },
        {
          dataIndex: "code_num",
          key: "code_num",
          slots: { title: "title_num" },
        },
        {
          title: "扫码录入时间",
          dataIndex: "created_at",
          key: "created_at",
        },
         {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ],
    });
    const $route = inject("$route");
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    //获取详情
    const getMore = async () => {
      const hide = message.loading("正在加载中...", 0);
      let res = await getWarehousingMore(props.id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(res)) {
        state.orderData = res.data;
        initData();
      } else {
        message.error(res.msg);
      }
      setTimeout(hide);
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //获取列表
    const initData = async () => {
      state.listLoading = true;
      let res = await getWarehousingCode({
        ...search.value,
        id: state.orderData.warehousing_sn,
      }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        state.list = res.data;
        state.total = res.meta.total;
        getNum();
      } else {
        message.error(res.msg);
      }
      state.listLoading = false;
    };
    //获取数量
    const getNum = async () => {
      let res = await getWarehousingCodeNum({
        ...search.value,
        id: state.orderData.warehousing_sn,
      }).then((res) => res.data);
      if (iscode(res)) {
        state.allNum = res.data.code_num;
      } else {
        message.error(res.msg);
      }
    };
    onMounted(() => {
      if ($route.query.type == "channel") {
        state.columns.splice(3, 0, {
          title: "退货人名称",
          dataIndex: "user_id",
          key: "user_id",
        });
      }
      getMore();
    });
    const del=(data)=>{
       Modal.confirm({
          centered: true,
          title:"确定删除该二维码",
          content: data.code_type_text=='大标'&&data.virtual_sn!=0?'使用虚拟垛标入库的大标需整垛回退':"确定删除?",
          onOk: async () => {
            let res = await delWarehousingCode(data.id).then((res) => res.data);
            if (iscode(res, true)) {
                 getMore();
            }
          },
        });
    }
    return {
      ...toRefs(state),
      changTime,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      search,
      del
    };
  },
};
</script>